/**
 * WishlistEngine v3 — Bara Bros
 * localStorage powered, Shein-style tabs + boards + share
 * Storage key: 'bb_wishlist_boards'
 * Structure: { boards: [{ id, name, createdAt, items: [{id,productId,title,image,url,price,vendor,addedAt}] }] }
 */
(function(global) {
  'use strict';
  var STORAGE_KEY = 'bb_wishlist_boards';
  var _debug = (global.BB_WISHLIST_DEBUG === true);

  /* ─── Storage ─── */
  function load() {
    try { var r = localStorage.getItem(STORAGE_KEY); return r ? JSON.parse(r) : {boards:[]}; } catch(e){ return {boards:[]}; }
  }
  function save(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      document.dispatchEvent(new CustomEvent('bb:wl:changed', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('bb:wl:changed', { detail: { source: 'boards-updated' }, bubbles: true }));
    } catch(e){}
  }
  function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2,7); }

  /* ─── Board API ─── */
  var WL = {
    getAll: function(){ return load(); },
    getBoards: function(){ return load().boards; },
    getBoard: function(id){ return load().boards.find(function(b){ return b.id===id; })||null; },
    createBoard: function(name){
      var data=load(), board={id:uid(),name:(name||'').trim()||'New Board',createdAt:Date.now(),updatedAt:Date.now(),items:[]};
      data.boards.push(board); save(data); return board;
    },
    renameBoard: function(id,name){
      var data=load();
      data.boards=data.boards.map(function(b){ if(b.id===id){ b.name=(name||'').trim()||b.name; b.updatedAt=Date.now(); } return b; });
      save(data);
    },
    deleteBoard: function(id){
      var data=load(); data.boards=data.boards.filter(function(b){ return b.id!==id; }); save(data);
    },
    addItem: function(boardId, item){
      var data=load(), board=data.boards.find(function(b){ return b.id===boardId; });
      if(!board) return false;
      if(board.items.some(function(i){ return i.productId===String(item.productId); })) return 'duplicate';
      board.items.unshift({id:uid(),productId:String(item.productId),title:item.title,image:item.image,url:item.url,price:item.price,vendor:item.vendor||'',addedAt:Date.now()});
      board.updatedAt=Date.now(); save(data); return true;
    },
    removeItem: function(boardId, itemId){
      var data=load(), board=data.boards.find(function(b){ return b.id===boardId; });
      if(board){ board.items=board.items.filter(function(i){ return i.id!==itemId; }); board.updatedAt=Date.now(); save(data); }
    },
    isProductInAnyBoard: function(pid){
      return load().boards.some(function(b){ return b.items.some(function(i){ return i.productId===String(pid); }); });
    },
    getBoardsContainingProduct: function(pid){
      return load().boards.filter(function(b){ return b.items.some(function(i){ return i.productId===String(pid); }); });
    },
    getAllItems: function(){
      var seen={}, items=[];
      load().boards.forEach(function(b){
        b.items.forEach(function(item){
          if(!seen[item.productId]){ seen[item.productId]=true; items.push(item); }
        });
      });
      return items;
    },
    getTotalCount: function(){ return WL.getAllItems().length; }
  };

  /* ─── Counter sync (works with Ella theme bubble) ─── */
  function updateWishlistCounters(){
    var count = WL.getTotalCount();
    /* our badges */
    document.querySelectorAll('[data-wl-count]').forEach(function(el){
      el.textContent = count>0?count:'';
      el.style.display = count>0?'flex':'none';
    });
    /* Ella theme bubble */
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el){ el.textContent=count; });
    document.querySelectorAll('.wishlist-count-bubble').forEach(function(el){
      el.style.display = count>0?'':'none';
    });
  }

  /* ─── Heart state ─── */
  function updateAllHearts(){
    document.querySelectorAll('[data-wl-heart]').forEach(function(btn){
      var active = WL.isProductInAnyBoard(btn.dataset.wlHeart);
      btn.classList.toggle('wl-heart-active', active);
      btn.classList.toggle('wishlist-added', active);
      btn.setAttribute('aria-label', active?'Remove from wishlist':'Add to wishlist');
      btn.setAttribute('title', active?'Remove from wishlist':'Add to wishlist');
      var empty=btn.querySelector('.wl-heart-empty'), filled=btn.querySelector('.wl-heart-filled');
      if(empty) empty.style.display = active?'none':'';
      if(filled) filled.style.display = active?'':'none';
    });
  }

  /* ─── Popup ─── */
  var currentProduct = null;

  function buildPopup(){
    if(document.getElementById('wl-popup-overlay')) return;
    var ovl=document.createElement('div');
    ovl.id='wl-popup-overlay';
    ovl.innerHTML=[
      '<div id="wl-popup">',
      '<button id="wl-popup-close" aria-label="Close">&times;</button>',
      '<div id="wl-popup-product"><img id="wl-popup-img" src="" alt=""><div id="wl-popup-info"><div id="wl-popup-title"></div><div id="wl-popup-price"></div></div></div>',
      '<h3 id="wl-popup-heading">Save to board</h3>',
      '<div id="wl-boards-list"></div>',
      '<div id="wl-new-board-wrap">',
      '<button id="wl-new-board-btn">+ New Board</button>',
      '<div id="wl-new-board-form" style="display:none">',
      '<input id="wl-new-board-input" type="text" placeholder="Board name\u2026" maxlength="40">',
      '<button id="wl-new-board-confirm">Create</button>',
      '</div></div></div>'
    ].join('');
    document.body.appendChild(ovl);
    ovl.addEventListener('click',function(e){ if(e.target===ovl) closePopup(); });
    document.getElementById('wl-popup-close').addEventListener('click',closePopup);
    document.getElementById('wl-new-board-btn').addEventListener('click',toggleNewBoardForm);
    document.getElementById('wl-new-board-confirm').addEventListener('click',handleCreateBoard);
    document.getElementById('wl-new-board-input').addEventListener('keydown',function(e){ if(e.key==='Enter') handleCreateBoard(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') closePopup(); });
  }

  function openPopup(product){
    currentProduct=product; buildPopup(); renderPopupBoards();
    document.getElementById('wl-popup-img').src=product.image||'';
    document.getElementById('wl-popup-title').textContent=product.title;
    document.getElementById('wl-popup-price').textContent=product.price||'';
    document.getElementById('wl-new-board-form').style.display='none';
    document.getElementById('wl-new-board-input').value='';
    var _list=document.getElementById('wl-boards-list'), _wrap=document.getElementById('wl-new-board-wrap');
    if(_list) _list.style.opacity=''; if(_wrap) _wrap.style.opacity='';
    document.getElementById('wl-popup-overlay').classList.add('wl-open');
    document.getElementById('wl-popup').classList.add('wl-open');
    document.body.style.overflow='hidden';
  }

  function closePopup(){
    var ovl=document.getElementById('wl-popup-overlay'); if(!ovl) return;
    ovl.classList.remove('wl-open');
    document.getElementById('wl-popup').classList.remove('wl-open');
    document.body.style.overflow=''; currentProduct=null;
    window.dispatchEvent(new CustomEvent('bb:wl:popup-closed'));
  }

  function renderPopupBoards(){
    var list=document.getElementById('wl-boards-list'); if(!list) return;
    var heading=document.getElementById('wl-popup-heading');
    if(heading){ heading.textContent='Save to board'; heading.style.color=''; }
    var boards=WL.getBoards();
    var savedIds=currentProduct?WL.getBoardsContainingProduct(currentProduct.productId).map(function(b){return b.id;}) :[];
    list.innerHTML='';
    if(boards.length===0){ list.innerHTML='<p class="wl-no-boards">No boards yet. Create one below.</p>'; return; }
    boards.forEach(function(board){
      var isSaved=savedIds.indexOf(board.id)!==-1;
      var btn=document.createElement('button');
      btn.className='wl-board-btn'+(isSaved?' wl-board-saved':'');
      btn.innerHTML='<span class="wl-board-icon">'+(isSaved?'&#9829;':'&#9825;')+'</span><span class="wl-board-name">'+esc(board.name)+'</span><span class="wl-board-count">'+board.items.length+' item'+(board.items.length!==1?'s':'')+'</span>'+(isSaved?'<span class="wl-board-check">Saved &#10003;</span>':'');
      btn.dataset.boardId=board.id;
      btn.addEventListener('click',function(){ handleSelectBoard(board.id,isSaved); });
      list.appendChild(btn);
    });
  }

  function handleSelectBoard(boardId,isSaved){
    if(!currentProduct) return;
    var board=WL.getBoard(boardId); if(!board) return;
    if(isSaved){
      // Toggle off — remove from this board
      var item=board.items.find(function(i){ return i.productId===String(currentProduct.productId); });
      if(item) WL.removeItem(boardId,item.id);
      renderPopupBoards(); updateAllHearts(); updateWishlistCounters();
    } else {
      // Move: remove from every board that currently holds this product, then add here
      var fromBoards=WL.getBoardsContainingProduct(currentProduct.productId);
      var fromNames=fromBoards.map(function(ob){ return ob.name; });
      fromBoards.forEach(function(ob){
        var oitem=ob.items.find(function(i){ return i.productId===String(currentProduct.productId); });
        if(oitem) WL.removeItem(ob.id,oitem.id);
      });
      WL.addItem(boardId,currentProduct);
      if(_debug) console.log('[BB Wishlist] Moved "'+( currentProduct.title||currentProduct.productId)+'" from ['+fromNames.join(', ')+'] → "'+board.name+'"');
      updateAllHearts(); updateWishlistCounters();
      showPopupSuccess(board.name);
    }
  }

  function showPopupSuccess(boardName){
    var heading=document.getElementById('wl-popup-heading');
    var list=document.getElementById('wl-boards-list');
    var newWrap=document.getElementById('wl-new-board-wrap');
    if(heading){ heading.textContent='✓ Saved to “'+boardName+'”'; heading.style.color='#00FF80'; }
    if(list) list.style.opacity='0.35';
    if(newWrap) newWrap.style.opacity='0.35';
    window.dispatchEvent(new CustomEvent('bb:wl:popup-saved',{detail:{productId:currentProduct?currentProduct.productId:null,boardName:boardName}}));
    setTimeout(closePopup,1200);
  }

  function toggleNewBoardForm(){
    var form=document.getElementById('wl-new-board-form');
    var open=form.style.display!=='none'; form.style.display=open?'none':'flex';
    if(!open) document.getElementById('wl-new-board-input').focus();
  }

  function handleCreateBoard(){
    var input=document.getElementById('wl-new-board-input'), name=(input.value||'').trim();
    if(!name){input.focus();return;}
    var board=WL.createBoard(name); input.value='';
    document.getElementById('wl-new-board-form').style.display='none';
    renderPopupBoards();
    if(currentProduct) handleSelectBoard(board.id,false);
  }

  /* ─── Heart click delegation ─── */
  function initHearts(){
    document.addEventListener('click',function(e){
      var btn=e.target.closest('[data-wl-heart]'); if(!btn) return;
      e.preventDefault(); e.stopPropagation();
      openPopup({
        productId:btn.dataset.wlHeart, title:btn.dataset.wlTitle||'',
        image:btn.dataset.wlImage||'', url:btn.dataset.wlUrl||window.location.href,
        price:btn.dataset.wlPrice||'', vendor:btn.dataset.wlVendor||''
      });
    });
  }

  /* ─── URL helpers ─── */
  function getParam(key){ return new URLSearchParams(window.location.search).get(key)||''; }
  function setParam(key,val){
    var p=new URLSearchParams(window.location.search);
    if(val) p.set(key,val); else p.delete(key);
    var url=window.location.pathname+(p.toString()?'?'+p.toString():'');
    window.history.pushState({},'' ,url);
  }
  function removeParam(key){ setParam(key,null); }

  /* ─── Share ─── */
  function shareboard(board){
    var url=window.location.origin+window.location.pathname+'?activeTab=2&board='+board.id;
    var text='Check out my "'+board.name+'" wishlist board on Bara Bros!';
    if(navigator.share){
      navigator.share({title:board.name, text:text, url:url}).catch(function(){});
    } else {
      navigator.clipboard.writeText(url).then(function(){
        showToast('Board link copied to clipboard!');
      }).catch(function(){
        // fallback
        var inp=document.createElement('input'); inp.value=url;
        document.body.appendChild(inp); inp.select(); document.execCommand('copy');
        document.body.removeChild(inp); showToast('Board link copied!');
      });
    }
  }

  function showToast(msg){
    var t=document.createElement('div'); t.className='wl-toast'; t.textContent=msg;
    document.body.appendChild(t);
    setTimeout(function(){ t.classList.add('wl-toast-show'); },10);
    setTimeout(function(){ t.classList.remove('wl-toast-show'); setTimeout(function(){ t.remove(); },300); },2800);
  }

  /* ─── Wishlist Page Renderer ─── */
  function renderWishlistPage(containerId){
    var container=document.getElementById(containerId); if(!container) return;

    function getActiveTab(){ var t=getParam('activeTab'); return t==='2'?'boards':'items'; }
    function getBoardId(){ return getParam('board')||''; }

    function render(){
      var tab=getActiveTab();
      var boardId=getBoardId();
      if(boardId){ renderBoardDetail(boardId); return; }
      renderTabShell(tab);
    }

    /* ── Tab shell ── */
    function renderTabShell(tab){
      var allItems=WL.getAllItems();
      var boards=WL.getBoards();
      var html='<div class="wl-page">';
      /* tabs */
      html+='<div class="wl-tabs">';
      html+='<button class="wl-tab'+(tab==='items'?' wl-tab-active':'')+'" data-tab="items">ITEMS('+allItems.length+')</button>';
      html+='<button class="wl-tab'+(tab==='boards'?' wl-tab-active':'')+'" data-tab="boards">BOARDS('+boards.length+')</button>';
      html+='</div>';
      /* content */
      html+='<div class="wl-tab-content">';
      if(tab==='items') html+=renderItemsTab(allItems);
      else html+=renderBoardsTab(boards);
      html+='</div></div>';
      container.innerHTML=html;
      bindTabEvents();
    }

    /* ── Items tab ── */
    function renderItemsTab(items){
      if(items.length===0){
        return '<div class="wl-empty"><div class="wl-empty-icon">&#9825;</div><h2>No saved items yet</h2><p>Tap the heart on any product to save it here.</p><a href="/collections/all" class="wl-empty-cta">Shop Now</a></div>';
      }
      var html='<div class="wl-items-grid">';
      items.forEach(function(item){
        html+=renderItemCard(item,null);
      });
      html+='</div>';
      return html;
    }

    /* ── Boards tab ── */
    function renderBoardsTab(boards){
      var html='<div class="wl-boards-page">';
      /* create new board */
      html+='<div class="wl-create-board-row" id="wl-create-board-row">';
      html+='<button class="wl-create-board-btn" id="wl-create-board-btn"><span class="wl-create-icon">+</span> Create a new board</button>';
      html+='<div id="wl-create-board-form" style="display:none">';
      html+='<input id="wl-create-board-input" type="text" placeholder="Board name\u2026" maxlength="40">';
      html+='<button id="wl-create-board-save">Create</button>';
      html+='<button id="wl-create-board-cancel">Cancel</button>';
      html+='</div></div>';

      if(boards.length===0){
        html+='<div class="wl-empty"><div class="wl-empty-icon">&#9825;</div><h2>No boards yet</h2><p>Create a board to organise your saved items.</p></div>';
      } else {
        html+='<div class="wl-boards-grid">';
        boards.forEach(function(board){
          html+=renderBoardCard(board);
        });
        html+='</div>';
      }
      html+='</div>';
      return html;
    }

    /* ── Board card (collage thumbnail) ── */
    function renderBoardCard(board){
      var imgs=board.items.slice(0,4);
      var html='<div class="wl-board-card" data-board-id="'+board.id+'">';
      /* collage */
      html+='<a href="?activeTab=2&board='+board.id+'" class="wl-board-collage wl-board-collage-'+Math.min(imgs.length,4)+'">';
      for(var i=0;i<4;i++){
        html+='<div class="wl-collage-cell">';
        if(imgs[i]) html+='<img src="'+esc(imgs[i].image)+'" alt="'+esc(imgs[i].title)+'" loading="lazy">';
        html+='</div>';
      }
      html+='</a>';
      /* info */
      var cfg = global.BBWishlistConfig || {};
      var showPrivacy = cfg.showPrivacyLabel !== false;
      var privacyText = cfg.privacyLabelText || 'Private';
      var enableShare = cfg.enableSharing !== false;
      var shareIcon  = cfg.shareIconSvg  ? cfg.shareIconSvg  : (cfg.shareIconUrl  ? '<img src="'+cfg.shareIconUrl+'"  style="width:14px;height:14px;object-fit:contain;vertical-align:middle;display:inline-block;" alt="">' : '&#10064;');
      var deleteIcon = cfg.deleteIconSvg ? cfg.deleteIconSvg : (cfg.deleteIconUrl ? '<img src="'+cfg.deleteIconUrl+'" style="width:14px;height:14px;object-fit:contain;vertical-align:middle;display:inline-block;" alt="">' : '&#128465;');
      html+='<div class="wl-board-card-info">';
      html+='<div class="wl-board-card-name">'+esc(board.name)+'</div>';
      html+='<div class="wl-board-card-meta">';
      html+='<span class="wl-board-card-count">'+board.items.length+' Item'+(board.items.length!==1?'s':''+(showPrivacy?' · <span class="wl-board-privacy">'+esc(privacyText)+'</span>':''))+'</span>';
      html+='<div class="wl-board-card-actions">';
      if(enableShare) html+='<button class="wl-share-btn" data-board-id="'+board.id+'" title="Share board">'+shareIcon+'</button>';
      html+='<button class="wl-delete-board-btn" data-board-id="'+board.id+'" title="Delete board">'+deleteIcon+'</button>';
      html+='</div></div></div>';
      html+='</div>';
      return html;
    }

    /* ── Board detail page ── */
    function renderBoardDetail(boardId){
      var board=WL.getBoard(boardId);
      if(!board){
        container.innerHTML='<div class="wl-empty"><h2>Board not found</h2><a href="?activeTab=2" class="wl-empty-cta">Back to boards</a></div>';
        return;
      }
      var cfg=global.BBWishlistConfig||{};
      var enableShare=cfg.enableSharing!==false;
      var shareIcon  = cfg.shareIconSvg  ? cfg.shareIconSvg  : (cfg.shareIconUrl  ? '<img src="'+cfg.shareIconUrl+'"  style="width:14px;height:14px;object-fit:contain;vertical-align:middle;display:inline-block;" alt="">' : '&#10064;');
      var deleteIcon = cfg.deleteIconSvg ? cfg.deleteIconSvg : (cfg.deleteIconUrl ? '<img src="'+cfg.deleteIconUrl+'" style="width:14px;height:14px;object-fit:contain;vertical-align:middle;display:inline-block;" alt="">' : '&#128465;');
      var html='<div class="wl-board-detail">';
      /* header: grid layout — back | actions / title / count */
      html+='<div class="wl-board-detail-header">';
      html+='<a href="?activeTab=2" class="wl-back-btn">&#8592; All Boards</a>';
      html+='<div class="wl-board-detail-actions">';
      if(enableShare) html+='<button class="wl-share-btn wl-share-btn-large" data-board-id="'+board.id+'">'+shareIcon+' Share Board</button>';
      html+='<button class="wl-delete-board-btn wl-delete-board-btn-large" data-board-id="'+board.id+'">'+deleteIcon+' Delete Board</button>';
      html+='</div>';
      html+='<div class="wl-board-detail-title-wrap">';
      html+='<h2 class="wl-board-detail-title" id="wl-bd-title">'+esc(board.name)+'</h2>';
      html+='<button class="wl-rename-inline-btn" data-board-id="'+board.id+'">&#9998; Rename</button>';
      html+='</div>';
      html+='<span class="wl-board-detail-count">'+board.items.length+' Item'+(board.items.length!==1?'s':'')+'</span>';
      html+='</div>';
      /* items */
      if(board.items.length===0){
        html+='<div class="wl-empty"><div class="wl-empty-icon">&#9825;</div><h2>No items in this board</h2><p>Go shopping and heart items to add them here.</p><a href="/collections/all" class="wl-empty-cta">Shop Now</a></div>';
      } else {
        html+='<div class="wl-items-grid">';
        board.items.forEach(function(item){ html+=renderItemCard(item,board.id); });
        html+='</div>';
      }
      html+='</div>';
      container.innerHTML=html;
      bindDetailEvents(boardId);
    }

    /* ── Item card ── */
    function renderItemCard(item,boardId){
      var removeAttr=boardId?'data-board-id="'+boardId+'" data-item-id="'+item.id+'"':'data-item-id="'+item.id+'"';
      var html='<div class="wl-item-card">';
      html+='<a href="'+esc(item.url)+'" class="wl-item-card-img"><img src="'+esc(item.image)+'" alt="'+esc(item.title)+'" loading="lazy"></a>';
      html+='<div class="wl-item-card-body">';
      html+='<a href="'+esc(item.url)+'" class="wl-item-card-title">'+esc(item.title)+'</a>';
      if(item.vendor) html+='<div class="wl-item-card-vendor">'+esc(item.vendor)+'</div>';
      if(item.price) html+='<div class="wl-item-card-price">'+esc(item.price)+'</div>';
      html+='<div class="wl-item-card-actions">';
      html+='<a href="'+esc(item.url)+'" class="wl-view-btn">View Product</a>';
      html+='<button class="wl-remove-item-btn" '+removeAttr+'>Remove</button>';
      html+='</div></div></div>';
      return html;
    }

    /* ── Bind events ── */
    function bindTabEvents(){
      container.querySelectorAll('.wl-tab').forEach(function(btn){
        btn.addEventListener('click',function(){
          setParam('activeTab', btn.dataset.tab==='boards'?'2':'1');
          removeParam('board');
          render();
        });
      });

      /* boards tab events */
      var createBtn=document.getElementById('wl-create-board-btn');
      var createForm=document.getElementById('wl-create-board-form');
      var createInput=document.getElementById('wl-create-board-input');
      var createSave=document.getElementById('wl-create-board-save');
      var createCancel=document.getElementById('wl-create-board-cancel');

      if(createBtn) createBtn.addEventListener('click',function(){ createForm.style.display='flex'; createBtn.style.display='none'; createInput.focus(); });
      if(createCancel) createCancel.addEventListener('click',function(){ createForm.style.display='none'; createBtn.style.display=''; createInput.value=''; });
      if(createSave) createSave.addEventListener('click',function(){
        var name=(createInput.value||'').trim(); if(!name) return;
        WL.createBoard(name); render();
      });
      if(createInput) createInput.addEventListener('keydown',function(e){ if(e.key==='Enter'&&createSave) createSave.click(); if(e.key==='Escape'&&createCancel) createCancel.click(); });

      /* board card clicks */
      container.querySelectorAll('.wl-board-card-name').forEach(function(el){
        el.addEventListener('click',function(){
          var boardId=el.closest('.wl-board-card').dataset.boardId;
          setParam('board',boardId); render();
        });
      });

      bindSharedEvents();
    }

    function bindDetailEvents(boardId){
      /* rename */
      container.querySelectorAll('.wl-rename-inline-btn').forEach(function(btn){
        btn.addEventListener('click',function(){
          var titleEl=document.getElementById('wl-bd-title');
          var input=document.createElement('input');
          input.type='text'; input.value=titleEl.textContent; input.className='wl-rename-input'; input.maxLength=40;
          titleEl.replaceWith(input); input.focus(); input.select();
          function commit(){ WL.renameBoard(btn.dataset.boardId,input.value||titleEl.textContent); render(); }
          input.addEventListener('blur',commit);
          input.addEventListener('keydown',function(e){ if(e.key==='Enter') commit(); if(e.key==='Escape'){ input.blur(); } });
        });
      });

      /* remove item from board */
      container.querySelectorAll('.wl-remove-item-btn').forEach(function(btn){
        btn.addEventListener('click',function(){
          var bid=btn.dataset.boardId||boardId, iid=btn.dataset.itemId;
          if(!bid){
            /* remove from all boards */
            WL.getBoards().forEach(function(b){
              var item=b.items.find(function(i){return i.id===iid;});
              if(item) WL.removeItem(b.id,iid);
            });
          } else { WL.removeItem(bid,iid); }
          updateAllHearts(); updateWishlistCounters(); render();
        });
      });

      bindSharedEvents();
    }

    function bindSharedEvents(){
      /* share buttons */
      container.querySelectorAll('.wl-share-btn').forEach(function(btn){
        btn.addEventListener('click',function(e){ e.stopPropagation(); var board=WL.getBoard(btn.dataset.boardId); if(board) shareboard(board); });
      });
      /* delete board */
      container.querySelectorAll('.wl-delete-board-btn').forEach(function(btn){
        btn.addEventListener('click',function(e){ e.stopPropagation();
          if(confirm('Delete this board and all its saved items?')){
            WL.deleteBoard(btn.dataset.boardId);
            updateAllHearts(); updateWishlistCounters();
            setParam('activeTab','2'); removeParam('board'); render();
          }
        });
      });
    }

    /* listen to popstate for back/forward */
    window.addEventListener('popstate', render);
    render();
  }

  /* ─── Escape ─── */
  function esc(str){
    return String(str||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  /* ─── Init ─── */
  function init(){
    initHearts(); updateAllHearts(); updateWishlistCounters();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();

  /* ─── Public ─── */
  global.WishlistEngine = { WL:WL, openPopup:openPopup, closePopup:closePopup, renderWishlistPage:renderWishlistPage, updateAllHearts:updateAllHearts, updateWishlistCounters:updateWishlistCounters };

})(window);
